import { gql } from '__generated__';

export default gql(`
  mutation AddNote($input: AddNoteInput!) {
    addNote(input: $input) {
      id
    }
  }
`);
